import { ProfileScreen } from '@/screens/profile-screen/ProfileScreen'

export default function ProfileRoute() {
  return <ProfileScreen />
}
